import { api } from '../../../index';
import { DiscoveryGroupResponse, UserGroupsResponse, UserOldGroupsResponse } from '../../types/useGroup.types';

export const getGroupsByNext = async (queryParams: string): Promise<DiscoveryGroupResponse> => {
  return await api.get<DiscoveryGroupResponse>(`signup/v2/next?${queryParams}`);
};

export const getUserGroupsByDiscovery = async (): Promise<UserGroupsResponse> => {
  return await api.get<UserGroupsResponse>('/account/find-matching-groups-by-discovery');
};

export const getUserCurrentGroups = async (): Promise<UserOldGroupsResponse[]> => {
  return await api.get<UserOldGroupsResponse[]>('/groups?updated=' + Date.now());
};

export const findGroupsOptions = async (): Promise<UserGroupsResponse> => {
  return await api.get<UserGroupsResponse>('/account/find-groups-options');
};

export const getOpenGroupsBySegment = async (segment: string): Promise<UserGroupsResponse> => {
  return await api.get<UserGroupsResponse>(`/signup/open-groups?type=audio-room&segment=${segment}`);
};
